import React from 'react';
import EditFieldModal from '../Edit items/EditFieldModal';
import { Card, CardHeader } from './primitives';

/*
 * The staff-only note on an order.
 *
 * Was a generic "Internal" card holding a label/value grid. Identity secret has
 * been dropped as unused, and shipping method moved to the Delivery card where
 * it belongs, which left the note as the only occupant — so the card is now
 * simply the note.
 *
 * Rendered as a block rather than a right-aligned Row value: a note is prose,
 * often more than one line, and the label/value layout squeezed it into a
 * narrow right-hand column where anything of length became unreadable.
 * `whitespace-pre-wrap` keeps the line breaks whoever wrote it intended.
 *
 * With nothing to show and no permission to add, the card removes itself
 * instead of occupying rail space to display a dash.
 */
const InternalCard = ({ order, orderId, isEditable, onSaved }) => {
  const note =
    typeof order.additional_note === 'string'
      ? order.additional_note.trim()
      : '';

  if (!note && !isEditable) return null;

  return (
    <Card>
      <CardHeader
        title="Internal note"
        action={
          isEditable && (
            <EditFieldModal
              fieldKey="additional_note"
              fieldLabel="Internal note"
              fieldValue={order.additional_note}
              id={orderId}
              modalId="editadditional_noteModal"
              title={note ? 'Edit internal note' : 'Add internal note'}
              placeholder="Only visible to staff"
              required={false}
              onSaved={onSaved}
            />
          )
        }
      />
      <div className="px-3.5 py-3">
        {note ? (
          <p className="m-0 text-[13px] font-medium text-nysmah-dark leading-relaxed whitespace-pre-wrap break-words">
            {note}
          </p>
        ) : (
          <p className="m-0 text-[12.5px] text-nysmah-muted">
            No note yet — only visible to staff.
          </p>
        )}
      </div>
    </Card>
  );
};

export default InternalCard;
